import fn from "@/utils/fn";

export const tabColumnList = [
  {
    title: "日期",
    key: "date",
    align: "center",
  },
  {
    title: "保证金充值总额",
    key: "total_recharge_amount",
    align: "center",
  },
  {
    title: "保证金盒币充值总额",
    key: "balance_recharge_amount",
    align: "center",
  },
  {
    title: "保证金支付宝充值金额",
    key: "ali_recharge_amount",
    align: "center",
  },
  {
    title: "保证金退款总金额",
    key: "total_refund_amount",
    align: "center",
  },
  {
    title: "保证金盒币退款金额",
    key: "balance_refund_amount",
    align: "center",
  },
  {
    title: "保证金支付宝退款金额",
    key: "ali_refund_amount",
    align: "center",
  },
  {
    title: "保证金收入",
    key: "income_amount",
    align: "center",
  },
];

export const gameTypeList = {
  total_amount: [
    { name: "交易总额由高到低", key: "desc" },
    { name: "交易总额由低到高", key: "asc" },
  ],
  success_order_num: [
    { name: "交易成功订单数由高到低", key: "desc" },
    { name: "交易成功订单数由低到高", key: "asc" },
  ],
};
